export default "__VITE_ASSET__60dfa306__"